import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ConfirmationService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { TranslateBaseComponent, UserContextRoleProfileStatusDTO, isAssigned, isEmpty } from '../../data';
import { TranslateService } from '@ngx-translate/core';
import { DataFieldComponent } from '../../data/components/data-field/data-field.component';

@Component({
    selector: 'app-user-context-role-scope-profile-header',
    templateUrl: './user-context-role-scope-profile-header.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonModule, TooltipModule, DataFieldComponent],
    providers: [ConfirmationService, DynamicDialogRef],
    host: {
        class: 'flex-none  justify-content-between flex flex-row gap-3',
    },
})
export class UserContextRoleScopeProfileHeaderComponent extends TranslateBaseComponent {
    @Input()
    profile?: UserContextRoleProfileStatusDTO;

    @Output()
    onClose = new EventEmitter();

    constructor(translateSrv: TranslateService) {
        super(translateSrv);
    }

    doClose() {
        this.onClose.emit();
    }
}
